import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { cacheCancelVideoTutorial } from "../../helper";
import Player from "react-player";

export default function VideoTutorial(props) {
  const { show, setShow, isMobile } = props;
  const [doNotShow, setDoNotShow] = useState(false);
  return (
    <Modal show={show} id="video-tutorial" centered={!isMobile}>
      <Modal.Header>
        <Modal.Title>Tutorial Video</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Player
          playsinline={true}
          url="tutorial.mp4"
          width="100%"
          height="55vh"
          controls={true}
          config={{ file: { attributes: { controlsList: "nodownload" } } }}
        />
        <div className="d-flex justify-content-center mt-4 mb-2 align-items-center">
          <Form.Check
            type="checkbox"
            label="Do not show this again"
            onChange={() => setDoNotShow(!doNotShow)}
          />
          <Button
            className="landing-button ml-3"
            variant="outline-warning"
            onClick={() => {
              cacheCancelVideoTutorial(!doNotShow);
              setShow(false);
            }}
          >
            {doNotShow ? "Apply and Close" : "Close"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
